import React from 'react';
import PropTypes from 'prop-types';

const JobFormatRenderer = (props) => {
  const value = props.value
  let cssText = "tw-text-yellow-600"

  if (value && value.includes("J"))
  {
    cssText = "tw-text-green-600"
  }

  return (
    <span className={cssText}>{value}</span>
  )
};

JobFormatRenderer.propTypes = {
  value: PropTypes.string.isRequired
}

export default JobFormatRenderer;
